<template>
  <div>
    <div class="card-vessel-position" v-if="!isMobileDevice || ( isMobileDevice &&  deviceInfo.deviceOrientation === 'landscape' )">
      <div class="camera-container" v-if="(isLiveMode || liveOnly) && radarCameras.length >= 1">
        <vessel-live-camera
          :camera="radarCameras[0]"
          :playerWidth="251"
          :playerHeight="370"
        ></vessel-live-camera>
      </div>
      <div class="map-container" :style="{ 'min-width': !((isLiveMode || liveOnly) && ( radarCameras.length >= 1 || optionCameras.length > 0 )) ? '100%' : (radarCameras.length >= 1 && deviceInfo.deviceType === 'PC' ) ? 'calc(100% - 324px - 273px)' : 'calc(100% - 324px)' }">
        <!-- Map -->
        <div id="vessel-position-map">
          <!-- Live Map -->
          <vessel-live-map
            v-if="isLiveMode || liveOnly"
            :vesselId="vesselId"
            :uniqueKey="uniqueKey"
            class="responsive card-img-top"
          ></vessel-live-map>
          <!-- History Map -->
          <vessel-voyage-history-map
            v-if="voyageHistoryDateTime && !liveOnly"
            :vessel_id="vesselId"
            :vessel_name="vesselName"
            :start_time="voyageHistoryDateTime.startTimeUtc"
            :end_time="voyageHistoryDateTime.endTimeUtc"
            class="responsive card-img-top"
            @onClickPrev="onClickPrev"
            @onClickNext="onClickNext"
          ></vessel-voyage-history-map>
        </div>
        <div v-if="showModeLabel" id="vessel-position-mode" class="mapboxgl-ctrl-top-left">
          <ul id="vessel-position-mode-label">
            <li>
              <p>{{ modeLabel }}</p>
            </li>
          </ul>
        </div>

      </div>
      <!-- カメラ -->
      <div id="vessel-position-live-camera-area" v-if="optionCameras.length > 0"  >
        <div class="mapboxgl-ctrl">

          <!-- Liveカメラ -->
          <div class="camera-area" v-if="isLiveMode || liveOnly" :style="{ width: isMobileDeviceLandscape ? '194px' : '324px' }">
            <div class="main-camera-container camera-container">
              <vessel-live-camera
                v-if="selectedCamera"
                :camera="selectedCamera"
                :playerWidth="isMobileDeviceLandscape ? 184 : 308"
                :playerHeight="isMobileDeviceLandscape ? 101 : 169"
                :key="incrementKey"
                :showControlBar="true"
              ></vessel-live-camera>
            </div>
            <div class="small-camera-area" :style="{ 'width': isMobileDeviceLandscape ? '194px' : '324px' }">
              <div :key="index" v-for="(camera, index) in optionCameras" @click="selectCamera(camera,index)"
                class="camera-container small-camera-container" :style="{ width: isMobileDeviceLandscape ? '87px' : '148px' }" >
                <div class="selected-mask" v-if="selectedCameraIndex == index"  :style="{ width: isMobileDeviceLandscape ? '87px' : '148px' ,height: isMobileDeviceLandscape ? '48px' : '82px' }" >
                  <feather-icon icon="CheckCircleIcon" svgClasses="h-7 w-7"/>
                </div>
                <div class="touch-area-mask" @click="selectCamera(camera,index)"  :style="{ width: isMobileDeviceLandscape ? '87px' : '148px' ,height: isMobileDeviceLandscape ? '48px' : '82px' }" >
                </div>
                <vessel-live-camera
                  :camera="camera"
                  :playerWidth="isMobileDeviceLandscape ? 87 : 148"
                  :playerHeight="isMobileDeviceLandscape ? 48 : 82"
                ></vessel-live-camera>
              </div>
            </div>
          </div>
          <!-- ヒストリーカメラ -->
        </div>
      </div>
    </div>
    <div v-else class="card-vessel-position mobile-layout">
      <div class="map-container">
        <!-- Map -->
        <div id="vessel-position-map">
          <!-- Live Map -->
          <vessel-live-map
            v-if="isLiveMode || liveOnly"
            :vesselId="vesselId"
            :uniqueKey="uniqueKey"
            class="responsive card-img-top"
          ></vessel-live-map>
          <!-- History Map -->
          <vessel-voyage-history-map
            v-if="voyageHistoryDateTime && !liveOnly"
            :vessel_id="vesselId"
            :vessel_name="vesselName"
            :start_time="voyageHistoryDateTime.startTimeUtc"
            :end_time="voyageHistoryDateTime.endTimeUtc"
            class="responsive card-img-top"
          ></vessel-voyage-history-map>
        </div>
        <div v-if="showModeLabel" id="vessel-position-mode" class="mapboxgl-ctrl-top-left">
          <div id="vessel-position-mode-label">
            <p>{{ modeLabel }}</p>
          </div>
        </div>

      </div>
      <div class="camera-container" v-if="(isLiveMode || liveOnly) && radarCameras.length >= 1">
        <vessel-live-camera
          :camera="radarCameras[0]"
          :playerWidth="251"
          :playerHeight="370"
        ></vessel-live-camera>
      </div>
      <!-- カメラ -->
      <div id="vessel-position-live-camera-area">
        <div class="mapboxgl-ctrl">
          <!-- Liveカメラ -->
          <div class="camera-area" v-if="isLiveMode || liveOnly">
            <div class="main-camera-container camera-container">
              <vessel-live-camera
                v-if="selectedCamera"
                :camera="selectedCamera"
                :key="incrementKey"
                customClass="vjs-4-3"
                :playerWidth="348"
                :playerHeight="189"
                :showControlBar="true"
              ></vessel-live-camera>
            </div>

            <div style="display: flex; overflow-x: auto; width: 100%;">
              <div :key="index" v-for="(camera, index) in optionCameras"
                class="camera-container small-camera-container"
                style="position: relative;"
                >
                <div class="selected-mask" v-if="selectedCameraIndex == index">
                  <feather-icon icon="CheckCircleIcon" svgClasses="h-7 w-7"/>
                </div>
                <div class="touch-area-mask" @click="selectCamera(camera,index)">
                </div>
                <vessel-live-camera
                  :camera="camera"
                  :playerWidth="160"
                  :playerHeight="90"
                ></vessel-live-camera>
              </div>
            </div>
          </div>
          <!-- ヒストリーカメラ -->
        </div>
      </div>
    </div>
    <div id="vessel-position-status" v-if="!voyageHistoryDateTime && !liveOnly">
      <vessel-live-status />
    </div>
    <div v-if="!liveOnly" id="timeline-controller-container" class="mt-6">
      <timeline-controller :vesselId="vesselId" ref="timeLineController" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "mapbox-gl/dist/mapbox-gl.css";
import { createNamespacedHelpers } from "vuex";
import {DeviceInfoMixin} from "@/mixins";

// components
import VesselLiveCamera from "./components/VesselLiveCamera";
import VesselLiveMap from "./components/VesselLiveMap";
import VesselLiveStatus from "./components/VesselLiveStatus";
import TimelineController from "./components/TimeLineControl";
import VesselVoyageHistoryMap from "./components/VesselVoyageHistoryMap";
import { CAMERA_MOVIE_TYPE } from "@/config/const.js";

// Store
const {
  mapActions: mapActionsOfVesselView,
  mapState: mapStateOfLiveVesselView,
  mapGetters: mapGettersOfVesselView
} = createNamespacedHelpers("enterpriseVesselView");

export default {
  name: "VesselPosition",
  components: {
    VesselLiveMap,
    VesselLiveStatus,
    VesselLiveCamera,
    VesselVoyageHistoryMap,
    TimelineController,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      initialized: false,
      hasLiveMapError: false,
      numberOfCamera: 0,
      subscribe: null,
      selectedCamera: null,
      selectedCameraIndex: null,
      optionCameras: [],
      radarCameras: [],
      incrementKey: 0,
      deviceInfo: null,
    };
  },
  props: {
    vesselId: { type: String, default: null },
    liveOnly: { type: Boolean, default: false },
    uniqueKey: { type: String, default: "" }
  },
  computed: {
    ...mapStateOfLiveVesselView({
      mode: state => state.mode,
      vessel: state => state.vessel,
      voyageHistoryDateTime: state => state.voyageHistoryDateTime,
      vesselPositionExpired10min: state => state.vesselPositionExpired10min
    }),

    ...mapGettersOfVesselView(["isLiveMode"]),

    ...mapGetters({
      style: "enterpriseMapSetting/getStyle"
    }),

    showModeLabel(){
      return !this.vesselPositionExpired10min || !this.isLiveMode
    },

    modeLabel() {
      return this.isLiveMode || this.liveOnly ? "Live" : "航海記録";
    },

    vesselName() {
      return this.vessel.name_ja ? this.vessel.name_ja : this.vessel.name;
    },

    isMobileDevice() {
      if (this.deviceInfo) {
        return this.deviceInfo.deviceType == "iPhone"
      } else {
        return false
      }
    },
    isMobileDeviceLandscape() {
      return this.isMobileDevice && this.deviceInfo.deviceOrientation === 'landscape';
    },
    vesselViewWidth() {
      const vesselViewRect =  document.getElementById('vessel-view').getBoundingClientRect();
      return vesselViewRect.width;
    }
  },
  watch: {
    vesselId: {
      immediate: true,
      handler: async function() {
        await this.setLiveCameras();
      }
    },
    async mode(val) {
      if (val === "Live") {
        await this.setLiveCameras();
      } else {
        // TODO 作成中
        //await this.setHistoryCameras();
      }
    },
    onChangeWindowSize() {
      this.deviceInfo = this.getDeviceInfo()
    },
  },
  methods: {
    ...mapActionsOfVesselView(["setViewMode", "fetchCameras", "setMode"]),

    async setLiveCameras() {
      let cameras = await this.fetchCameras(this.vesselId);
      for (let index = 0; index < cameras.length; index++) {
        const element = cameras[index];
        if (element.movie_type === CAMERA_MOVIE_TYPE.CAMERA || element.movie_type === CAMERA_MOVIE_TYPE.HLS_CAMERA|| element.movie_type === CAMERA_MOVIE_TYPE.MEDIAMTX) {
          this.optionCameras.push(element)
        } else if (element.movie_type === CAMERA_MOVIE_TYPE.RADAR || element.movie_type === CAMERA_MOVIE_TYPE.HLS_RADAR ) {
          this.radarCameras.push(element)
        }
      }

      if (this.optionCameras.length >= 1) {
        this.selectedCamera = this.optionCameras[0]
        this.selectedCameraIndex = 0
      }
    },
    selectCamera(selectedCamera, index) {
      this.selectedCamera = selectedCamera
      this.selectedCameraIndex = index
      this.incrementKey++
    },

    cleanup() {
      this.resetEnterpriseVesselViewState();
    },
    onClickPrev() {
      this.$refs.timeLineController.onClickPrev();
    },
    onClickNext() {
      this.$refs.timeLineController.onClickNext();
    },
  },
  created() {
    this.deviceInfo = this.getDeviceInfo()
    if (this.initialMode == "live" || this.initialMode == "history") {
      this.setMode(this.initialMode);
    }
  },
  beforeDestroy() {
    if (this.storeUnsubscribe) {
      this.storeUnsubscribe();
    }
  }
};
</script>

<style lang="scss">
.mapboxgl-ctrl-attrib-inner {
  display: none !important;
}
.mapboxgl-ctrl-bottom-right {
  display: block !important;
}
</style>

<style lang="scss">
#vessel-position-map {
  height: 370px;
  object-fit: scale-down;
}

#vessel-position-mode-label {
  margin: 20px;
  list-style: none;
  overflow: hidden;
  height: 40px;
  width: 100px;
  border-radius: 5px;
  text-align: center;
  background-color: #5097d5;
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 -50% 0 0;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
}
}
#vessel-position-area {
}
#vessel-position-live-camera-area {
  margin-bottom: 0px;
  &.mobile-layout {
    width: auto;
  }
}

.live-camera-card {
  border-radius: 0 !important;
  .vx-card {
    border-radius: 0 !important;
  }
}

#player-controller-container {
  position: relative;
}

#timeline-controller-container {
  position: relative;
  background-color: #f2f2f2;
  height: 160px;
}

.map-overlay-container {
  color: black;
  position: absolute;
  width: 38%;
  top: 0;
  left: 0;
  padding: 10px;
  z-index: 1;
}

.map-overlay {
  color: black;
  background-color: #fff;
  border-radius: 3px;
  padding: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.map-overlay h2,
.map-overlay p {
  margin: 0 0 10px;
}

.mapboxgl-canvas {
  position: inherit !important;
}

.map-overlay-container-no-info {
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: black;
  border-radius: 3px;
  opacity: 0.8;
  .map-overlay-no-info {
    top: 50%;
    left: 50%;
    color: #fff;
    position: relative;
    p {
      position: absolute;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      height: 100%;
      width: 80%;
      text-align: center; /*一応BOX内の文字も中央寄せ*/
    }
  }


}
.camera-container {
  margin: 7px;
  pointer-events: auto !important;

  .video-js {
    border-radius: 8px;
    overflow: hidden;
  }
}

.camera-area {
  width: 324px;
}
.mobile-layout {
  .camera-area {
    width: 100%;
  }
  .camera-container {
    margin: 0px;
  }
  .main-camera-container {
    margin-top: 5px;
    .video-js {
      width: 100%;
    }
  }
  #vessel-position-live-camera-area {
    width: 100%;
  }
  .small-camera-area {
    height: 210px;
    justify-content: space-between;
    .small-camera-container {
      margin: 5px 0px !important;
      position: relative;
    }
  }
  .selected-mask {
    width: 160px;
    height: 90px;
  }
}

.small-camera-area {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
  height: 192px;
  .small-camera-container {
    margin: 5px;
    position: relative !important;
  }
}
.map-container {
  flex: 1;
  overflow: auto;
  margin: 7px;
  position: relative;
  .mapboxgl-canvas {
    border-radius: 8px;
    overflow: hidden;
  }
  .map-overlay-container-no-info {
    border-radius: 8px;
  }
  &.mobile-layout {
    flex: none;
  }
}
.card-vessel-position {
  display: flex;
  &.mobile-layout {
    flex-wrap: wrap;
    justify-content: center;
    .map-container {
      flex: none;
      width: 100%;
    }
  }
}

.selected-mask {
  position: absolute;
  z-index: 1;
  width: 150px;
  height: 84px;
  background: rgba(26, 25, 25, 0.6);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}
.touch-area-mask {
  position: absolute;
  z-index: 2;
  width: 150px;
  height: 84px;
}

</style>
